// Page entry for Patient Inquiry Management (PRD 12).
//   - CUSTOMER_SUPPORT:NO_PERMISSION → LNB hidden + entry blocked (redirect home
//     via useRequirePermission below).
//   - READ → list + detail (read-only).
//   - WRITE / Root → reply + additional reply.
//
// Slice 4: permission guard + header + filter bar + list table + pagination +
// detail slide panel with the reply / additional-reply flow (WRITE-gated),
// wired to the API-ready service/mock layer.

import { useTranslation } from 'react-i18next';

import { useRequirePermission } from '@/shared/hooks/useRequirePermission';
import { PatientInquiryDetailPanel } from '@/features/patient-inquiry/components/PatientInquiryDetailPanel';
import { PatientInquiryListFilters } from '@/features/patient-inquiry/components/PatientInquiryListFilters';
import { PatientInquiryListView } from '@/features/patient-inquiry/components/PatientInquiryListView';
import { usePatientInquiryDetailStore } from '@/features/patient-inquiry/store/patient-inquiry-detail.store';

export function PatientInquiryManagementPage() {
  const { t } = useTranslation('admin');
  const canRead = useRequirePermission('CUSTOMER_SUPPORT', 'READ');
  const openDetail = usePatientInquiryDetailStore((s) => s.open);

  if (!canRead) return null;

  return (
    <>
      <div className="content__header">
        <div>
          <h1 className="content__title">{t('patientInquiry.title')}</h1>
        </div>
      </div>
      <div className="content__body">
        <PatientInquiryListFilters />
        <PatientInquiryListView onRowClick={openDetail} />
      </div>
      <PatientInquiryDetailPanel />
    </>
  );
}
